import request from "./../utils/request";

export function listChannels(includeDeleted = false) {
    return request({
        url: includeDeleted ? "/channel/list?includeDeleted=true" : "/channel/list",
        method: "get",
        params: {},
    });
}

export const CHANNEL_API = {
    listChannels,
};

export function createChannel(
    type,
    name,
    payload,
    visibility = {
        users: [],
        departments: [],
    },
    forward,
    commentForward,
    owner,
) {
    return request({
        url: "/channel",
        method: "put",
        data: {
            type,
            name,
            forward,
            commentForward,
            payload,
            visibility,
            owner,
        },
    });
}

export function updateChannel(
    id,
    name,
    enabled,
    payload,
    visibility = {
        users: [],
        departments: [],
    },
    forward,
    commentForward,
    zohoForward,
    autoAssignDisabled,
    capi,
    accountNotifications,
) {
    if (forward) {
        if (forward.mode === "live" && !!forward.story) {
            forward.mode = "chatbot";
        } else if (forward.mode !== "live" && !forward.story) {
            forward.mode = "live";
        }
    }

    return request({
        url: `/channel/${id}`,
        method: "post",
        data: {
            name,
            enabled,
            payload,
            visibility,
            forward,
            commentForward,
            zohoForward,
            autoAssignDisabled,
            capi,
            accountNotifications,
        },
    });
}

export function deleteChannel(id) {
    return request.delete(`/channel/${id}`);
}

export function getTeamGramPipelines(id) {
    return request.get(`/channel/${id}/teamgram-pipelines`);
}


export function getPostacellChannelSenders(id) {
    return request.get(`/channel/${id}/postcell-senders`).then((res) => res.data);
}

export function getPostacellChannelCredit(id) {
    return request.get(`/channel/${id}/postcell-credit`).then((res) => res.data);
}

export function getReconnectChannelURL(id){
    return request.get(`/channel/${id}/reconnect`).then((res) => res.data);
}

export function resetWhatsappUnipileChannel(id) {
    return request.post(`/channel/${id}/reset-whatsapp-unipile`).then((res) => res.data);
}

export function completeWABAOnboard(channelId, data) {
    console.log("completeWABAOnboard data", data);
    return request.post(`/channel/${channelId}/complete-waba-onboard`, data);
}
